import React from "react";
import { useSelector } from "react-redux";

/**
 * Onboarding Header - Simplified Branding (Clean)
 */
const Header = () => {
  const navigatorState = useSelector(state => state.navigator);

  return (
    	<header className="fixed top-0 right-0 left-0 lg:left-[16rem] h-20 flex items-center px-4 md:px-16 bg-custom-pink border-b border-slate-200 z-50 shadow-sm"> 
  
			<div className="w-full flex justify-center">
				{/* Wrapping gap instead of fixed spacing: at 19 steps a single fixed-gap
				    row ran off the side of a phone screen. */}
				<div className="flex max-w-full flex-wrap items-center justify-center gap-y-2 gap-x-1.5 sm:gap-x-3 md:gap-x-5 lg:gap-x-8">
					{Array.from({ length: navigatorState.maxSteps }, (_, i) => i + 1).map((_, index) => (
						<React.Fragment key={index}>
							{index + 1 === navigatorState.currentStep ? (
									<div className="h-3 w-3 flex-none rounded-full bg-custom-orange shadow-sm ring-4 ring-orange-200/60 transition-all"></div>
								) : (
									<div
										className={`h-2.5 w-2.5 flex-none rounded-full transition-all ${
										index + 1 < navigatorState.currentStep
											? 'bg-custom-gray'
											: 'border-2 border-gray-300 bg-white'
										}`}
									></div>
							)}
						</React.Fragment>
					))}
				</div>
			</div>

        </header>
    )
}

export default Header;
